import React from 'react'

function Hero() {
    return ( 
        <div className='container'>
            <div className='row text-center mt-5'>
                <h1 style={{opacity:"90%"}}>We pioneered the discount broking model in India.
                Now, we are breaking ground with our technology.</h1>
                <div className='col-6 mt-5 pt-5'>
                    <p>We kick-started operations on the 15th of August, 2010 with the goal of breaking all barriers that traders and investors face in India in terms of cost, support, and technology. We named the company Zerodha, a combination of Zero and "Rodha", the Sanskrit word for barrier.

Today, our disruptive pricing models and in-house technology have made us the biggest stock broker in India.

Over 1+ Crore clients place millions of orders every day through our powerful ecosystem of investment platforms, contributing over 15% of all Indian retail trading volumes.</p>
                </div>
                <div className='col-6 mt-5 pt-5'>
                    <p>In addition, we run a number of popular open online educational and community initiatives to empower retail traders and investors.

<a href='#'>Rainmatter</a>, our fintech fund and incubator, has invested in several fintech startups with the goal of growing the Indian capital markets.

And yet, we are always up to something new every day. Catch up on the latest updates on our blog or see what the media is <a href='#'>saying about us.</a></p>
                </div>
            </div>
        </div>
     );
}

export default Hero;